export const getAliasName = (name) => {
  switch (name) {
  case 'email': {
    return 'em';
  }
  case 'phone': {
    return 'ph';
  }
  case 'firstName': {
    return 'fn';
  }
  case 'lastName': {
    return 'ln';
  }
  default: {
    return '';
  }
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getAliasName.js